export default {
  SET_DEALER_GROUPS: (state, data) => {
    state.dealer_groups = data;
  },
  SET_DEALER_GROUP: (state, data) => {
    state.dealer_group = data;
  },
};
